import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { PRODUCTION } from '@curbnturf/entities';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { AgritourismAppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Call the element loader before the bootstrapModule/bootstrapApplication call
defineCustomElements(window);

if (PRODUCTION) {
  enableProdMode();
}

bootstrapApplication(AgritourismAppComponent, appConfig).catch((err) => {
  console.log('app error');
  console.error(err);
});
